import { useCallback } from 'react';
import { BORROWER_DASHBOARD_URL } from '@common/config/environments';
import { useGetOAuthToken } from 'services/auth/mutations';

const isOnDashboard = (): boolean => {
  try {
    const dashboardOrigin = new URL(BORROWER_DASHBOARD_URL || '').origin;
    return window.location.origin === dashboardOrigin;
  } catch {
    return true;
  }
};

export const useRedirectToDashboard = () => {
  const { execute: getOAuthToken } = useGetOAuthToken();

  const redirectToDashboard = useCallback(async (
    loanId: string,
    queryParams?: Record<string, string>
  ) => {
    if (isOnDashboard()) {
      const params = queryParams ? `?${new URLSearchParams(queryParams)}` : '';
      window.location.href = `${BORROWER_DASHBOARD_URL}/home/${loanId}${params}`;
      return;
    }

    try {
      const { data } = await getOAuthToken({});
      const token = data?.getOAuthToken;

      if (token) {
        const params = new URLSearchParams({ oauth: token, isNew: 'true', loanId });
        if (queryParams) {
          Object.entries(queryParams).forEach(([key, value]) => params.set(key, value));
        }
        window.location.href = `${BORROWER_DASHBOARD_URL}/?${params}`;
      } else {
        const params = queryParams ? `?${new URLSearchParams(queryParams)}` : '';
        window.location.href = `${BORROWER_DASHBOARD_URL}/home/${loanId}${params}`;
      }
    } catch {
      const params = queryParams ? `?${new URLSearchParams(queryParams)}` : '';
      window.location.href = `${BORROWER_DASHBOARD_URL}/home/${loanId}${params}`;
    }
  }, [getOAuthToken]);

  return { redirectToDashboard };
};
